import React, {useState} from 'react'
import Modal from '../../../../accountManagement/shared/Modal'
import {Button} from '../../../../accountManagement/shared/Button'
import {Input} from '../../../../accountManagement/shared/Input'
import {useAuthClient} from '../../../../utils/use-auth-client'

// Mirrors legacy src/components/catalog-components/website-settings-modal.js —
// shown whenever Professionally Designed Website is selected, whether as the
// standalone addon-5-website_difm add-on or the ent-5-website entitlement
// bundled on a Center (e.g. Marketing Center Pro). "No existing site" keeps
// the Website Design Fee (thryvdesg2); "Yes" + a validated domain waives it —
// see the isWebsiteDesignFeeWaived check in productSelectionRules.js.
//
// No close button/backdrop/Esc dismissal (mirrors the legacy modal's hideX +
// disableBackdropClick) — Continue is the only way out, so the selection
// always resolves to an explicit answer.
export function WebsiteSettingsModal({isOpen, onContinue}) {
  const client = useAuthClient()
  const [hasExistingWebsite, setHasExistingWebsite] = useState(false)
  const [domain, setDomain] = useState('')
  const [validation, setValidation] = useState(null)
  const [isValidating, setIsValidating] = useState(false)

  const reset = () => {
    setHasExistingWebsite(false)
    setDomain('')
    setValidation(null)
    setIsValidating(false)
  }

  const handleValidate = async () => {
    if (!domain.trim()) return
    setIsValidating(true)
    try {
      const response = await client(`orders/validate-website/${domain}`)
      setValidation(response)
    } catch {
      setValidation({
        status: 'invalid',
        statusMessage: 'Unable to validate this domain.',
      })
    } finally {
      setIsValidating(false)
    }
  }

  const handleContinue = () => {
    const isDomainValid = hasExistingWebsite && validation?.status === 'valid'
    onContinue({
      hasExistingWebsite,
      domain: hasExistingWebsite ? domain : null,
      isDomainValid,
    })
    reset()
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {}}
      title="Website"
      showCloseButton={false}
      closeOnBackdrop={false}
      closeOnEsc={false}
      width="500px"
      footer={
        <Button type="button" variant="primary" onClick={handleContinue}>
          Continue
        </Button>
      }
    >
      <div style={{display: 'flex', flexDirection: 'column', gap: '16px'}}>
        <div>
          <p style={{marginBottom: '8px', fontWeight: 600}}>
            Do you have an existing published website you wish to transfer?
          </p>
          <label style={{marginRight: '16px', cursor: 'pointer'}}>
            <input
              type="radio"
              name="hasExistingWebsite"
              checked={!hasExistingWebsite}
              onChange={() => setHasExistingWebsite(false)}
            />{' '}
            No
          </label>
          <label style={{cursor: 'pointer'}}>
            <input
              type="radio"
              name="hasExistingWebsite"
              checked={hasExistingWebsite}
              onChange={() => setHasExistingWebsite(true)}
            />{' '}
            Yes
          </label>
        </div>
        {hasExistingWebsite && (
          <div style={{display: 'flex', gap: '8px', alignItems: 'flex-start'}}>
            <div style={{flex: 1}}>
              <Input
                placeholder="Your Domain"
                value={domain}
                onChange={e => {
                  setDomain(e.target.value)
                  setValidation(null)
                }}
                errorText={
                  validation?.status === 'invalid'
                    ? validation.statusMessage
                    : undefined
                }
              />
              {validation?.status === 'valid' && (
                <p
                  style={{
                    color: '#16A085',
                    fontSize: '12px',
                    margin: '4px 0 0',
                  }}
                >
                  {validation.statusMessage ?? 'Domain validated.'}
                </p>
              )}
            </div>
            <Button
              type="button"
              variant="secondary"
              isLoading={isValidating}
              onClick={handleValidate}
            >
              Validate
            </Button>
          </div>
        )}
      </div>
    </Modal>
  )
}
